import * as STD from '@emersya/mpa-std';
import * as CM from '@emersya/mpa-components-manager';
import {InputButton} from '@emersya/mpa-components';

export interface IPlannerWallColorTileComponentConfiguration extends InputButton.Configuration {
	SKU: string;
	component: string;
};

export class PlannerWallColorTileComponent extends InputButton.Component {
	static override getInputEventSubType() {
		const parentClass = (<typeof CM.Component>(<any>this.prototype).__proto__.constructor);
		if (!parentClass) {
			throw STD.errors.library('Should inherits from Input Button', {});
		}
		return parentClass.type;
	};

	override async component_start(ev: STD.events.Event<any, any>) {
		await super.component_start(ev);
	};

	constructor(
		descriptor: ConstructorParameters<typeof CM.Component>[0],
		configuration: IPlannerWallColorTileComponentConfiguration
	) {
		super(descriptor, configuration);
	};
};
export namespace NS {
	export const Component = PlannerWallColorTileComponent;
	export type Component = PlannerWallColorTileComponent;
	export type Configuration = IPlannerWallColorTileComponentConfiguration;
}
;
import manifestXMLSource from './PlannerWallsOptionTile.xml';
import './PlannerWallsOptionTile.scss';

CM.Manager.declare({
	id: 'viewer-planner-walls-optionTile',
	type: PlannerWallColorTileComponent,
	manifest: manifestXMLSource
});
